export enum DiscountType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
}



// WEBPACK FOOTER //
// ./src/app/pages/coupons/enums/discount-type.enum.ts